import { ArrowRight, Check } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const planPoints = [
  "Central screen dashboard",
  "Media, playlists, and channels",
  "Virtual screen preview",
  "Workspace and role controls",
  "Billing and audit visibility",
];

export function Pricing() {
  return (
    <section id="pricing" className="section-wrap pricing-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Pricing"
          title="Simple per-screen pricing for growing signage networks."
          body="Transparent licensing for every active display, with monthly or annual billing and enterprise support for larger deployments."
          center
        />

        <div className="mt-12 grid gap-5 lg:grid-cols-3">
          <article className="price-card">
            <p className="price-label">Monthly</p>
            <div className="price-line">
              <span>$10</span>
              <em>per screen / month</em>
            </div>
            <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20monthly%20plan" className="btn-primary w-full justify-center">
              Get Started
              <ArrowRight size={17} aria-hidden="true" />
            </a>
          </article>

          <article className="price-card price-card-featured">
            <p className="price-label">Annual</p>
            <div className="price-line">
              <span>$100</span>
              <em>per screen / year</em>
            </div>
            <ul>
              {planPoints.map((point) => (
                <li key={point}>
                  <Check size={16} aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
            <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20annual%20plan" className="btn-primary w-full justify-center">
              Book a Demo
              <ArrowRight size={17} aria-hidden="true" />
            </a>
          </article>

          <article className="price-card">
            <p className="price-label">Enterprise</p>
            <div className="price-line">
              <span>Custom</span>
              <em>for larger deployments</em>
            </div>
            <p className="price-note">
              Custom onboarding, multi-space rollout support, invoicing needs, and roadmap integration planning.
            </p>
            <a href="mailto:admin@pulsepanels.com?subject=PulsePanels%20enterprise%20plan" className="btn-secondary-light w-full justify-center">
              Contact Sales
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}
